enum DistributorCustomerOnboardingStateEnum {
  Registered = "Registered",
  Onboarded = "Onboarded",
}

export default DistributorCustomerOnboardingStateEnum;
